import { memo } from 'react'
import { Dropdown, InputText } from 'ui_kit_qmd'
import {
  GENDER_IDENTITY,
  IDENTITY_SECTION,
  MARITAL_STATUS_OPTIONS,
  MARITAL_STATUS_TEXT,
  RACIAL_BACKGROUND,
  SEX_AT_BIRTH_TEXT,
  RACIAL_BACKGROUND_OPTIONS,
  SEX_AT_BIRTH_OPTIONS,
  ASTERISK_TEXT,
} from '../../../../../../utils/constants'
import { EditCardAccountInfo } from '../../../edit-card-account-info/EditCardAccountInfo'
import { setIdentityReducerState } from '../../reducers/IdentityReducer'
import './EditIdentityBlock.scss'

const dropdownContainerStyle = {
  width: '100%',
  marginBottom: 44,
}

const dropdownHeight = {
  height: 145,
}

const sexAtBirthHeight = {
  height: 'max-content',
}

const inputContainerStyle = {
  marginBottom: 44,
  width: '100%',
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const EditIdentityBlock = memo(({ stateInfo, dispatchInfo }) => {
  const { maritalStatus, sexAtBirth, genderIdentity, racialBackground } = stateInfo

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeMaritalStatus = (value) => {
    dispatchInfo(setIdentityReducerState({ maritalStatus: value }))
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeGenderIndentity = (value) => {
    dispatchInfo(setIdentityReducerState({ genderIdentity: value }))
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeRacialBackground = (value) => {
    dispatchInfo(setIdentityReducerState({ racialBackground: value }))
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeSexAtBirth = (value) => {
    dispatchInfo(setIdentityReducerState({ sexAtBirth: value }))
  }

  return (
    <EditCardAccountInfo title={IDENTITY_SECTION}>
      <div className='edit-identity-block-main-wrapper'>
        <Dropdown
          dropId='edit-identity-block-marital-status'
          isStateDropdown
          options={MARITAL_STATUS_OPTIONS}
          containerStyle={dropdownContainerStyle}
          dropdownContainerStyle={dropdownHeight}
          label={MARITAL_STATUS_TEXT}
          setValue={onChangeMaritalStatus}
          value={maritalStatus}
        />

        <Dropdown
          dropId='edit-identity-block-sex-at-background'
          isStateDropdown
          options={SEX_AT_BIRTH_OPTIONS}
          containerStyle={dropdownContainerStyle}
          dropdownContainerStyle={sexAtBirthHeight}
          label={`${SEX_AT_BIRTH_TEXT}${ASTERISK_TEXT}`}
          setValue={onChangeSexAtBirth}
          value={sexAtBirth}
        />

        <InputText
          label={GENDER_IDENTITY}
          maxLength={50}
          containerStyle={inputContainerStyle}
          value={genderIdentity}
          view='visitType'
          setValue={onChangeGenderIndentity}
        />
        <Dropdown
          dropId='edit-identity-block-racial-background'
          isStateDropdown
          options={RACIAL_BACKGROUND_OPTIONS}
          containerStyle={dropdownContainerStyle}
          dropdownContainerStyle={dropdownHeight}
          label={RACIAL_BACKGROUND}
          setValue={onChangeRacialBackground}
          value={racialBackground}
        />
      </div>
    </EditCardAccountInfo>
  )
})
